import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../../components/base/PageLayout';

const CorporateTraining: React.FC = () => {
  useEffect(() => {
    document.title = '企業研修・セミナー - 執事が教えるホスピタリティ・マナー研修｜執事ベル';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '執事ベルによる企業向けホスピタリティ研修・マナーセミナーのご案内。接客力向上、ビジネスマナー、VIP対応、コミュニケーションスキルなど、企業のニーズに合わせたオーダーメイドプログラムを提供。ホテル、レストラン、小売、金融など業種別の研修実績多数。全日本執事協会頭取として培った実践的なノウハウで、社員のサービス品質と顧客満足度を向上させます。');
    }
  }, []);

  const programs = [
    {
      title: 'ホスピタリティ研修',
      description: '心からのおもてなしの精神を身につける基礎研修',
      duration: '1日間',
      participants: '10-30名',
      features: [
        'おもてなしの心構え',
        '顧客心理の理解',
        '感動を生む接客術',
        '実践ロールプレイング'
      ]
    },
    {
      title: 'ビジネスマナー講座',
      description: '社会人として必要な基本マナーの習得',
      duration: '半日間',
      participants: '5-20名',
      features: [
        '挨拶・言葉遣い',
        '名刺交換',
        '電話応対',
        'メール作法'
      ]
    },
    {
      title: 'リーダーシップ研修',
      description: '執事の視点から学ぶリーダーシップ',
      duration: '2日間',
      participants: '8-15名',
      features: [
        '先読み力の養成',
        'チーム統率術',
        '問題解決能力',
        '部下育成法'
      ]
    }
  ];

  return (
    <PageLayout hero={<>
<section 
          className="relative py-32 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/generated/seq-corp-training-hero-7ff709.jpg')`
          }}
        >
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center text-white">
              <h1 className="text-4xl md:text-6xl font-serif mb-6">
                企業研修・セミナー
              </h1>
              <p className="text-xl md:text-2xl max-w-6xl mx-auto leading-relaxed">
                執事文化の研究と実践を通じて学んだ<br />
                真のホスピタリティを企業様に
              </p>
            </div>
          </div>
        </section>
</>}>
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white">
        {/* Hero Section */}
        

        {/* Overview */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-6">
                  企業の価値を高める<br />
                  本格的な研修プログラム
                </h2>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  全日本執事協会頭取として、執事文化の本質—相手を思いやる心と洗練された所作—を企業様の接客品質向上とスタッフ教育に活かすお手伝いをいたします。理論だけでなく、実際の現場で即活用できる実践的な内容をお届けします。
                </p>
                <div className="grid grid-cols-2 gap-6">
                  <div className="text-center p-4 bg-amber-50 rounded-lg">
                    <div className="text-2xl font-bold text-amber-700 mb-2">実践重視</div>
                    <div className="text-sm text-gray-600">現場で活かせる</div>
                  </div>
                  <div className="text-center p-4 bg-amber-50 rounded-lg">
                    <div className="text-2xl font-bold text-amber-700 mb-2">個別対応</div>
                    <div className="text-sm text-gray-600">ニーズに合わせて</div>
                  </div>
                </div>
              </div>
              <div>
                <img
                  src="/images/generated/bcb432171499678e2080085be63acf54.png"
                  alt="企業研修の様子"
                  className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Programs */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">
                研修プログラム
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                企業様のニーズに合わせてカスタマイズ可能な研修メニュー
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {programs.map((program, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-8">
                  <h3 className="text-2xl font-serif text-gray-900 mb-4">
                    {program.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {program.description}
                  </p>
                  
                  <div className="flex justify-between mb-6 text-sm text-gray-600">
                    <div>
                      <span className="font-medium">期間：</span>
                      <span>{program.duration}</span>
                    </div>
                    <div>
                      <span className="font-medium">人数：</span>
                      <span>{program.participants}</span>
                    </div>
                  </div>

                  <div className="mb-6">
                    <h4 className="text-lg font-medium text-gray-900 mb-3">主な内容</h4>
                    <ul className="space-y-2">
                      {program.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-center text-gray-700">
                          <div className="w-2 h-2 bg-amber-500 rounded-full mr-3 flex-shrink-0"></div>
                          <span className="text-sm">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">
                研修で目指すこと
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: 'ri-customer-service-2-line',
                  title: '接客品質向上',
                  description: 'お客様に感動を提供するサービスの実現'
                },
                {
                  icon: 'ri-team-line',
                  title: 'チーム力強化',
                  description: 'スタッフ間の連携と協力体制の構築'
                },
                {
                  icon: 'ri-trophy-line',
                  title: 'ブランド価値向上',
                  description: '企業イメージと信頼性の向上'
                },
                {
                  icon: 'ri-line-chart-line',
                  title: '継続的成長',
                  description: '持続可能なサービス改善の実現'
                }
              ].map((benefit, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-amber-100 rounded-full">
                    <i className={`${benefit.icon} text-2xl text-amber-700`}></i>
                  </div>
                  <h3 className="text-xl font-serif text-gray-900 mb-4">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">
                研修で大切にしていること
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                {
                  title: 'おもてなしの本質理解',
                  description: '形だけでなく、心からのサービスを提供できる人材の育成を目指します。相手を思いやる心を大切にし、その心が自然と行動に表れるような指導を行います。',
                  icon: 'ri-heart-line'
                },
                {
                  title: '実践的スキル習得',
                  description: '研修後すぐに現場で活用できる、具体的で実践的な技術をお伝えします。理論と実践のバランスを重視し、参加者の皆様と共に学ぶ姿勢を大切にしています。',
                  icon: 'ri-tools-line'
                }
              ].map((goal, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-8">
                  <div className="w-16 h-16 flex items-center justify-center mb-6 bg-amber-100 rounded-full">
                    <i className={`${goal.icon} text-2xl text-amber-700`}></i>
                  </div>
                  <h3 className="text-xl font-serif text-gray-900 mb-4">{goal.title}</h3>
                  <p className="text-gray-700 leading-relaxed">
                    {goal.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-amber-700 to-amber-800">
          <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6">
              研修のお問い合わせ
            </h2>
            <p className="text-xl text-amber-100 mb-8 leading-relaxed">
              企業様のニーズに合わせたオーダーメイド研修をご提案いたします
            </p>
            <Link
              to="/contact"
              className="btn-gold inline-block bg-white text-amber-800 px-8 py-4 rounded-lg font-medium hover:bg-amber-50 transition-colors whitespace-nowrap"
            >
              お見積もり依頼
            </Link>
          </div>
        </section>
      </div>
    </PageLayout>
  );
};

export default CorporateTraining;
